import { ISoftDeletableFilterParameters } from "../../../../api/GenericTypes";

export interface ISoftDeletableEntityForm {
  includeSoftDeleted?: boolean;
}

export const SoftDeletableEntityDefaultFilterFormValues: Required<ISoftDeletableEntityForm> = {
  includeSoftDeleted: false,
};

export const softDeletableEntityFormToFilters = <Filters extends Partial<ISoftDeletableFilterParameters>>(
  form: ISoftDeletableEntityForm
): Filters => {
  let filters = {} as Filters;
  filters.includeSoftDeleted = form.includeSoftDeleted ?? false;
  return filters;
};

export const softDeletableEntityFiltersToForm = (
  filters: Partial<ISoftDeletableFilterParameters>
): ISoftDeletableEntityForm => {
  return {
    includeSoftDeleted: filters.includeSoftDeleted ?? false,
  };
};
